import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const settingStorageClear = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:storage:clear`, 
        category: settings.categoryName 
    });
};

export default settingStorageClear;